import { LatLng } from './types'

const fromLngLatArrayToObject = ([lng, lat]: [number, number]): LatLng => ({ lng, lat })

export default fromLngLatArrayToObject
